export default __webpack_public_path__ + "static/media/ENTREGADO2.6bf4b702.png";